module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/manual-lottery/manual-grid/manual-grid.component.css
// module id = ./src/app/allocation/manual-lottery/manual-grid/manual-grid.component.css
// module chunks = main